import { render, staticRenderFns } from "./detailPanel.vue?vue&type=template&id=11b6c008&scoped=true&"
import script from "./detailPanel.vue?vue&type=script&lang=js&"
export * from "./detailPanel.vue?vue&type=script&lang=js&"
import style0 from "./detailPanel.vue?vue&type=style&index=0&id=11b6c008&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11b6c008",
  null
  
)

export default component.exports